/* GS: start videos rendered by snippets/gs-lazy-video.liquid only after load and when they get near the screen. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const start = (video) => {
    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.load();
    if (!video.hasAttribute('data-autoplay')) return;
    if (reduce) {
      video.controls = true;
      return;
    }
    const playing = video.play();
    if (playing) playing.catch(() => {});
  };
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          start(entry.target);
        });
      }, { rootMargin: '300px 0px' })
    : null;
  const scan = (root) => {
    root.querySelectorAll('video[data-gs-lazy]:not([data-gs-seen])').forEach((video) => {
      video.setAttribute('data-gs-seen', '');
      observer ? observer.observe(video) : start(video);
    });
  };
  // Wait for the page's own images first so videos never compete with them
  if (document.readyState === 'complete') scan(document);
  else window.addEventListener('load', () => scan(document), { once: true });
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  // Product grids re-render on filtering and pagination
  let queued = false;
  new MutationObserver(() => {
    if (queued || document.readyState !== 'complete') return;
    queued = true;
    requestAnimationFrame(() => { queued = false; scan(document); });
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
